<script setup lang="ts">
import {useI18n} from "vue-i18n";

const emit = defineEmits(['close'])
const {t} = useI18n()
</script>

<template>
  <div class="sidebar-panel is-generic">
    <div class="subpanel-header">
      <h3 class="no-mb">{{t('sidebar-user')}}</h3>
      <div class="panel-close" @click="emit('close')">
        <i aria-hidden="true" class="iconify" data-icon="feather:x"></i>
      </div>
    </div>
    <div class="inner" data-simplebar>
      <ul>
        <li>
          <RouterLink :to="{ name: 'users-list' }">
            <i class="lnir lnir-user-alt" aria-hidden="true"></i>
            {{ t('sidebar-user-list') }}
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="{ name: 'users-group-list' }">
            <i
              aria-hidden="true"
              class="iconify sidebar-svg"
              data-icon="feather:users"
            ></i>
            {{ t('sidebar-roadshow-user-group') }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
@import '../../scss/abstracts/_variables.scss';
@import '../../scss/layout/_sidebar-panel.scss';
</style>
